import HttpService from './HttpService';
import { getUrlMessageApi, translate, getApiKeyLogistics, showMessageToastCustom } from '../utils/util';
import { startLoading, endLoading } from '../actions/loadingAction';
import * as auth from './auth';
import * as messageAction from '../actions/messageAction';

const httpService = new HttpService(getUrlMessageApi(window), getApiKeyLogistics(window));

export default class MessageService {
    static AddDeviceToken = () => {
        const deviceKeyAdd = {
            messageType: 'deviceKey',
            token: auth.getToken(),
            urlBase: getUrlMessageApi(window)
        };
        const content = window.ReactNativeWebView;
        if (content) {
            content.postMessage(JSON.stringify(deviceKeyAdd));
        }
    }

    static GetNotifications(vision, filter, pagination) {
        pagination.PageSize = 40;
        Object.assign(filter, pagination);
        const url = 'notification';
        return (dispatch) => {
            if (navigator.onLine) {
                dispatch(startLoading());
                httpService.instance.get(
                    url,
                    {
                        params: filter,
                        timeout: process.env.REACT_APP_DEFAULT_RESQUEST_TIMEOUT,
                        timeoutErrorMessage: translate('general.timeout')
                    }
                ).then((response) => {
                    if (response.status === 200) {
                        dispatch(messageAction.setMessages(response.data.data));
                    }
                }).catch((error) => {
                    dispatch(endLoading());
                    return error;
                }).finally(() => {
                    dispatch(endLoading());
                });
            }
        };
    }

    static PutNotification = (notification, callback) => {
        const url = 'notification';
        return (dispatch) => {
            if (navigator.onLine) {
                dispatch(startLoading());
                httpService.instance.put(url, notification, { timeout: 360000, timeoutErrorMessage: translate('general.timeout') }).then((response) => {
                    if (response.status === 200) {
                        if (callback) {
                            callback(response.data);
                        }
                    } else {
                        showMessageToastCustom(translate('warning', 'general'), response?.data?.message, 8000, 'mdi mdi-alert-circle-outline red-text');
                    }
                }).catch((error) => {
                    dispatch(endLoading());
                    showMessageToastCustom(translate('warning', 'general'), error.response?.data?.message || error.message, 8000, 'mdi mdi-alert-circle-outline red-text');
                }).finally(() => {
                    dispatch(endLoading());
                });
            }
        };
    }

    static live(callback) {
        const url = 'live';
        return () => {
            if (navigator.onLine) {
                httpService.instance.get(url).then((response) => {
                    callback(response);
                }).catch((error) => {
                    callback(error);
                })
            }
        };
    }


    static GetNotificationById(id, callback) {
        const url = `notification/${id}`;
        return (dispatch) => {
            if (navigator.onLine) {
                dispatch(startLoading());
                httpService.instance.get(
                    url,
                    {
                        timeout: process.env.REACT_APP_DEFAULT_RESQUEST_TIMEOUT,
                        timeoutErrorMessage: translate('general.timeout')
                    }
                ).then((response) => {
                    if (response.status === 200 && response.data?.data) {
                        callback(response.data?.data);
                    }
                }).catch((error) => {
                    dispatch(endLoading());
                    return error;
                }).finally(() => {
                    dispatch(endLoading());
                });
            }
        };
    }
}
